/* eslint-disable no-unused-vars */
import { RefObject, useRef } from 'react'
import { useGSAP } from '@gsap/react'
import ScrollTrigger from 'gsap/dist/ScrollTrigger'

import { useLenis } from '@/contexts/lenis'
import { useLoaderStore } from '@/store/loader'
import { useRouterStore } from '@/store/router'
import { isTouch } from '@/utils/device'

import { Animation } from '@/types'

type MotionProps = {
  children: (ref: RefObject<HTMLDivElement>) => React.ReactNode
  animation: (props: Animation<HTMLElement>) => (() => void) | void // gsap.core.Timeline
  nodeRef?: RefObject<HTMLElement>
  revertOnUpdate?: boolean
}

const Motion = ({
  nodeRef,
  children,
  animation,
  revertOnUpdate = true
}: MotionProps) => {
  const root = useRef<HTMLDivElement>(null!)
  const heroLoaded = useLoaderStore((state) => state.heroLoaded)

  const { lenis } = useLenis()

  useGSAP(
    (context) => {
      if (!lenis || !heroLoaded || isTouch) return

      const isInViewport = ScrollTrigger.isInViewport(root.current)
      const isLanding = useRouterStore.getState().previousRoute === undefined

      const revert = animation({
        node: root.current,
        mobile: false,
        reverse: false,
        nodeRef,
        context,
        delay: isLanding && isInViewport ? 0.3 : 0
      })

      return () => {
        if (revert) {
          revert()
        }
      }
    },
    {
      dependencies: [lenis, heroLoaded],
      scope: nodeRef || root,
      revertOnUpdate
    }
  )

  return children(root)
}

export default Motion
